interface IProps {
  className?: string;
}

export const InfoIcon = ({ className }: IProps) => {
  return (
    <svg
      className={className}
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00013 7.875C5.10646 7.875 5.1955 7.83904 5.26725 7.76713C5.33908 7.69529 5.375 7.60625 5.375 7.5V5.375C5.375 5.26875 5.33904 5.17967 5.26713 5.10775C5.19521 5.03592 5.10612 5 4.99988 5C4.89354 5 4.8045 5.03592 4.73275 5.10775C4.66092 5.17967 4.625 5.26875 4.625 5.375V7.5C4.625 7.60625 4.66096 7.69529 4.73288 7.76713C4.80479 7.83904 4.89388 7.875 5.00013 7.875ZM5 4.14425C5.11442 4.14425 5.21033 4.10554 5.28775 4.02813C5.36517 3.95071 5.40387 3.85479 5.40387 3.74037C5.40387 3.62596 5.36517 3.53004 5.28775 3.45263C5.21033 3.37529 5.11442 3.33662 5 3.33662C4.88558 3.33662 4.78967 3.37529 4.71225 3.45263C4.63483 3.53004 4.59613 3.62596 4.59613 3.74037C4.59613 3.85479 4.63483 3.95071 4.71225 4.02813C4.78967 4.10554 4.88558 4.14425 5 4.14425ZM5.00087 10.25C4.34387 10.25 3.72633 10.1253 3.14825 9.876C2.57017 9.62667 2.06733 9.28829 1.63975 8.86088C1.21217 8.43346 0.873625 7.93083 0.624125 7.353C0.374708 6.77517 0.25 6.15779 0.25 5.50087C0.25 4.84387 0.374667 4.22633 0.624 3.64825C0.873333 3.07017 1.21171 2.56733 1.63913 2.13975C2.06654 1.71217 2.56917 1.37362 3.147 1.12412C3.72483 0.874708 4.34221 0.75 4.99913 0.75C5.65613 0.75 6.27367 0.874666 6.85175 1.124C7.42983 1.37333 7.93267 1.71171 8.36025 2.13913C8.78783 2.56654 9.12638 3.06917 9.37588 3.647C9.62529 4.22483 9.75 4.84221 9.75 5.49913C9.75 6.15613 9.62533 6.77367 9.376 7.35175C9.12667 7.92983 8.78829 8.43267 8.36088 8.86025C7.93346 9.28783 7.43083 9.62638 6.853 9.87588C6.27517 10.1253 5.65779 10.25 5.00087 10.25Z"
        fill="#4CAAFF"
      />
    </svg>
  );
}
